import React, { FC, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactElement;
}

interface Position {
  top: number;
  left: number;
}

const Tooltip: FC<TooltipProps> = ({ content, children }) => {
  const [position, setPosition] = useState<Position | null>(null);
  const ref = useRef<HTMLElement | null>(null);

  const handleMouseEnter = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY - 8,
        left: rect.left + window.scrollX + rect.width / 2,
      });
    }
  };

  const handleMouseLeave = () => setPosition(null);

  const child = React.cloneElement(children, {
    ref,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
  });

  return (
    <>
      {child}
      {position &&
        ReactDOM.createPortal(
          <div
            style={{
              position: 'absolute',
              top: position.top,
              left: position.left,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999,
              pointerEvents: 'none',
            }}
          >
            <div
              style={{
                background: 'rgba(30, 41, 59, 0.95)',
                color: '#f1f5f9',
                borderRadius: 6,
                padding: '6px 10px',
                fontSize: 12,
                lineHeight: 1.5,
                whiteSpace: 'pre-line',
                maxWidth: 220,
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
              }}
            >
              {content}
            </div>
            {/* arrow */}
            <div
              style={{
                position: 'absolute',
                bottom: -5,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 0,
                height: 0,
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: '5px solid rgba(30, 41, 59, 0.95)',
              }}
            />
          </div>,
          document.body
        )}
    </>
  );
};

export default Tooltip;
